import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="mobile-sidebar"
export default class extends Controller {
  static targets = ['toggleButton'];
  static values = {open: Boolean};

  toggle() {
    this.openValue = !this.openValue;
  }

  close() {
    this.openValue = false;
  }

  closeOnEscape(event) {
    if (event.key !== 'Escape') { return }

    this.close();
  }

  closeOnOutsideClick(event) {
    if (this.element.contains(event.target)) { return }

    this.close();
  }

  // The open state lives in the DOM, the panel and the burger animate from it in CSS.
  openValueChanged() {
    if (!this.hasToggleButtonTarget) { return }

    this.toggleButtonTarget.setAttribute('aria-expanded', this.openValue);
  }
}
